import _ from 'lodash';
export const ordersToCsv = (transactions, runName, runId, customFileName) => {
  const { isAdmin, isBetaUser } = window;
  const headerData = ['Transaction', 'Instrument', 'Qty', 'Entry', 'Entry Price', 'Entry Time',
    'Exit', 'Exit Price', 'Exit Time', 'Profit'];

  const csvDataFormat = [];

  if (isAdmin || isBetaUser) {
    headerData.push('Min Profit');
    headerData.push('Max Profit');
    csvDataFormat.push(headerData);
  } else {
    csvDataFormat.push(headerData);
  }

  _.each(transactions, (transaction) => {
    const { transactionNumber, pairedOrders } = transaction;
    _.each(pairedOrders, (ordersPair) => {
      const {
        entryType, exitType, entryTime, exitTime, orderProfit, entryPrice,
        exitPrice, quantity, tradingSymbol, orderProfitMax, orderProfitMin
      } = ordersPair;

      const formattedEntryTime = entryTime?.format('DD MMM YYYY HH:mm:ss');
      const formattedExitTime = exitTime?.format('DD MMM YYYY HH:mm:ss');

      const rowData = [
        transactionNumber, tradingSymbol, quantity, _.upperCase(entryType), _.round(entryPrice, 2),
        `${formattedEntryTime}`, _.upperCase(exitType),
        _.round(exitPrice, 2), `${formattedExitTime || ''}`, _.round(orderProfit, 2)
      ];

      if (isAdmin || isBetaUser) {
        rowData.push(orderProfitMin || '');
        rowData.push(orderProfitMax || '');
        csvDataFormat.push(rowData);
      } else {
        csvDataFormat.push(rowData);
      }
    });
  });

  const csvContent = `data:text/csv;charset=utf-8,${csvDataFormat.map((e) => e.join(',')).join('\n')}`;
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement('a');
  const csvFileName = customFileName || `${runId}-${runName}.csv`;
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', csvFileName);
  document.body.appendChild(link);
  link.click();
};
